import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { DisplayEuroMUI } from '../../../../../../../utils/formats';
import { enumT } from '../../../../../../../utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import { Box } from '@mui/material';
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../../../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

const KostenUebersichtAntragEpz: FC<{ kostenArt: string }> = ({ kostenArt }) => {
	const { application } = useApplication();
	const columns = useMemo(() => {
		let column = [
			{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
			...Array.from({ length: get(application, P.Allgemein_Projektdauerin_Jahren.path) }).map((_, i) => {
				return {
					field: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
					headerName: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
					flex: 1,
					type: 'number' as const,
					valueFormatter: (value: any) => {
						return !isNaN(value) ? DisplayEuroMUI(value) : DisplayEuroMUI(0);
					},
				};
			}),
			{
				field: 'geplanteSumme',
				headerName: 'Geplante Summe',
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return !isNaN(value) ? DisplayEuroMUI(value) : DisplayEuroMUI(0);
				},
			},
		];

		if (kostenArt === KOSTEN_ARTEN.Personalkosten) {
			column.splice(1, 0, { field: 'bezeichnung', headerName: 'Funktion im Vorhaben', flex: 1, groupable: false });
		}
		if (kostenArt === KOSTEN_ARTEN.Sachkosten) {
			column.splice(1, 0, { field: 'bezeichnung', headerName: 'Bezeichnung', flex: 1, groupable: false });
		}

		return column;
	}, [application, kostenArt]);

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === kostenArt)
			.map((ele: any) => {
				const kostenProJahr = get(ele, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).reduce((acc: any, proJahr: any) => {
					acc[get(proJahr, 'Zelle_1')] = get(proJahr, 'Zelle_2');
					return acc;
				}, {});
				return {
					id: get(ele, 'id'),
					kostraeger: get(ele, KP_P.Allgemein_Kostentraeger.path, ''),
					bezeichnung: get(ele, KP_P.Allgemein_Bezeichnung.path, ''),
					unternehmen: get(ele, KP_P.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path),
					name: get(ele, KP_P.Personalausgaben_Emob_Antrag.schema.attributes.Emob_Antrag_Name_Desder_Beschaeftigten.path),
					kostenart: get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					...kostenProJahr,
					geplanteSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
	}, [application, kostenArt]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					geplanteSumme: 'sum',
				},
			},
			sorting: {
				sortModel: [
					{
						field: 'kostenKategorie',
						sort: 'asc',
					},
				],
			},
		};
	}, [application]);
	return (
		<>
			<ApplicationHeading title={`${enumT(kostenArt)} Übersicht`} description={PLATZHALTER_TEXT} />

			<Box sx={{ height: 'auto', width: '100%' }}>
				{' '}
				<DataGridPremium
					rows={rows}
					columns={columns}
					initialState={initialState}
					hideFooter
					disableRowSelectionOnClick
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</Box>
		</>
	);
};

export default KostenUebersichtAntragEpz;
